import React from 'react';
import { Icons } from '@myob/myob-widgets';
import { TextWrapper, TileWrapper } from 'modules/BillingAndPayments/components/Tile/styles';
import * as telemetry from 'telemetry';
import { ETelemetryActionsAndLabels, ETelemetryNames } from 'telemetry/type';

export type TProps = {
    title: string;
    description: string;
    image: string;
    link: string;
    linkText: string;
    target?: '_blank';
    buttonName: 'PaymentDetails' | 'MydotInvoices' | 'MyBills';
};
const Tile: React.FC<TProps> = ({ title, description, image, link, linkText, target, buttonName }) => {
    const onClickLink = () => {
        telemetry.track(ETelemetryNames.BillingAndPaymentsDashboard, {
            action: ETelemetryActionsAndLabels.Click,
            label: ETelemetryActionsAndLabels.Click,
            clickData: { buttonName },
        });
    };

    return (
        <TileWrapper>
            <div className="top">
                <TextWrapper>
                    <h2>{title}</h2>
                    <p>{description}</p>
                </TextWrapper>
                <img src={image} alt="tile image" />
            </div>
            <a className="bottom" href={link} target={target} onClick={onClickLink}>
                <span>{linkText}</span>
                <Icons.ArrowRight />
            </a>
        </TileWrapper>
    );
};

export default Tile;
